import React from 'react';
import clsx from 'clsx';
import './Spinner.css';

/**
 * Spinner component
 * sizes: sm | md | lg
 */
function Spinner({ size = 'md', className, ...props }) {
  return (
    <img
      src="/loader.gif"
      className={clsx('spinner', `spinner--${size}`, className)}
      alt="Loading"
      role="status"
      aria-label="Loading"
      {...props}
    />
  );
}

export default Spinner;
